module.exports = __webpack_public_path__ + "img/ic_prev_testimonial.06cf36c7.svg";